export default class ModelType {
    /**
     * @param modelClassName
     */
    constructor(modelClassName) {
        this.modelClassName = modelClassName;
    }

    /**
     * @returns {array}
     */
    getModelClassName() {
        return this.modelClassName;
    }
}